const timeline = {
  btnReset: 'Reset',
  edit: 'Edit',
  filters: {
    status: {
      placeholder: 'Status',
      options: {
        'new': 'New',
        'in-route': 'In Route',
        'sent': 'Sent',
        'approved': 'Approved',
        'done': 'Done',
        'canceled': 'Canceled',
        'picking_up': 'Picking Up',
      },
    },
    driver: 'Driver',
    vehicle: 'Vehicle',
    areas: 'Zones',
    locations: 'Locations',
    airportLocations: 'Airport Locations',
    driverShifts: 'Show Driver Shifts',
    showUnassignedTrips: 'Show Unassigned Trips',
  },
  alerts: {
    etaChanged: 'ETA to stops {{stopsIds}} of trip {{tripId}} has been updated - Driver has been notified by the system.',
  },
  assigenModal: {
    header: 'Assign Driver',
    description: 'Please select a driver/vehicle from the list below',
    driver: 'Choose Driver',
    vehicle: 'Choose Vehicle',
    button: 'Assign',
  },
  toast: {
    toastSomethingWasWrong: 'Something was wrong',
    assignedTrips: '{{numOfTrips}} trips has been assgned',
  },
  empty: 'No Trips At The Last 24 Hours',
  driverAndVehicle: 'Driver & Vehicle',
  driverInfo: {
    phoneNumber: 'Phone Number',
    lettersLeft: 'Letters Left',
    sendMessage: 'Send Message',
  },
  actions: {
    manualAssign: 'Manual Assign',
    removeAssign: 'Remove Assign',
    assignInsights: 'Assign Insights',
  },
  tripInformation: {
    trip: 'Trip #{{id}}',
  },
  stopInfo: {
    stopNumber: 'Stop #{{number}}',
    tripId: 'Trip: {{id}}',
    pta: 'PTA: {{pta}}',
    eta: 'ETA: {{eta}}',
    totalReservations: '{{count}} reservations',
    pickupReservations: '{{count}} pickups',
    dropReservations: '{{count}} drop-offs',
    totalSeats: '{{count}} seats',
    table: {
      header: {
        reqAppt: 'Req/Appt',
        passenger: 'Passenger',
        bookingId: 'Booking ID',
        seats: 'Seats',
        zones: 'Zones',
        attributes: 'Attributes',
      },
      sections: {
        pickups: 'PICKUPS',
        dropoffs: 'DROPOFFS',
        request: 'Request',
        appt: 'Appt',
      },
    },
  },
};

export default timeline;
